import {
  faTimesCircle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { ErrorMessage, Form, Formik } from "formik";
import * as Yup from "yup";
import FormikControl from "../../components/WraapperComponent/FormikControl";

import { useDispatch, useSelector } from "react-redux";
import { settingsPostAction } from "../../actions/settingsActions";
const SchoolFormPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.alert.appLoading);
  const initialValues = {
    name: "",
    email: "",
    url: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().nullable().required("This field is required"),
    email: Yup.string().nullable().email().required("This field is required"),
    url: Yup.string().nullable().url().required("This field is required"),
  });

  const handleSubmission = (values) => {
    const params = {
      name: values.name,
      email: values.email,
      url: values.url,
      action: "requestSchool",
    };
    dispatch(
      settingsPostAction(
        {
          params,
        },
        () => {
          closePopup();
        }
      )
    );
  };

  return (
    <Modal size="lg" show={true} id="subscription-popup">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">School Information</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body className="content-wrapper">
        <div className="detail-wrapper">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmission}
          >
            {({ errors, touched, setFieldValue, handleBlur }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* School Name"
                        name="name"
                        handleBlur={handleBlur}
                        hasError={errors.name && touched.name}
                      />
                    </div>
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* School Email"
                        name="email"
                        handleBlur={handleBlur}
                        hasError={errors.email && touched.email}
                      />
                    </div>
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* School Url"
                        name="url"
                        handleBlur={handleBlur}
                        hasError={errors.url && touched.url}
                      />
                    </div>
                  </div>
                  <div className="submit-section mt-2 d-flex justify-content-end">
                    <button
                      className="btn-orange"
                      type="submit"
                      disabled={appLoading}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default SchoolFormPopup;
